var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmphrEth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80.0962C62.0914 80.0962 80 62.1876 80 40.0962C80 18.0048 62.0914 0.0961914 40 0.0961914C17.9086 0.0961914 0 18.0048 0 40.0962C0 62.1876 17.9086 80.0962 40 80.0962Z",
    fill: "url(#paint0_linear_719_549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9947 6.7627L39.5576 8.28194V52.3633L39.9947 52.8097L59.988 40.7145L39.9947 6.7627Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.994 6.7627L20 40.7145L39.994 52.8097V31.4137V6.7627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9944 56.684L39.748 56.9912V72.6936L39.9944 73.4296L60 44.5952L39.9944 56.684Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.994 73.4296V56.684L20 44.5952L39.994 73.4296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9932 52.8093L59.9868 40.7145L39.9932 31.4136V52.8093Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40.7145L39.994 52.8093V31.4136L20 40.7145Z",
    fill: "#E7E7E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_549",
    x1: 40,
    y1: 0.0961914,
    x2: 40,
    y2: 80.0962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F50D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7002B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.0961914)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmphrEth);
export default __webpack_public_path__ + "static/media/amphrETH.266883ffe9b3a6474cb9c03d2932ca98.svg";
export { ForwardRef as ReactComponent };